// Generated from src/img/svg/s1.svg

export const S1 = (props) => {
  return (
    <svg viewBox="0 0 26 13" {...props}>
      <rect fill="#0abae6" height="13" rx="6.5" width="25" x=".5" />
      <g
        aria-label="S1"
        style={{
          fill: "#fff",
          fontFamily: 'HelveticaNeue-Bold,"Helvetica Neue"',
          fontSize: "10px",
          fontWeight: "700",
          transform: "translate(1px,0)",
        }}
      >
        <path d="M6.715 7.63h1.52q0 .67.48 1.02.41.3 1.1.3.54 0 .9-.17.49-.23.49-.72 0-.61-1.1-.92-1.9-.54-2.05-.62-1.1-.53-1.1-1.67 0-1.03.85-1.63.76-.53 1.82-.53 1.23 0 1.99.53.87.61.87 1.77h-1.52q-.06-1.08-1.41-1.08-.43 0-.73.18-.35.22-.35.63 0 .39.39.57.3.14 1.74.51.84.21 1.25.48.87.56.87 1.6 0 1.02-.76 1.64-.8.65-2.21.65-1.29 0-2.12-.61-.93-.69-.92-1.93M16.885 3v7h-1.42V5.46h-1.76V4.39q1.85.04 2.05-1.39z" />
      </g>
    </svg>
  );
};
